import React, { useState } from "react";
import { AiOutlineEdit, AiOutlineDelete, AiOutlineEye,AiOutlineUser } from "react-icons/ai"; // ✅ Import icons
import DynamicTable from "../../../components/tables/Dynamictable";
import { UserApi, useUserProperties } from "../../../API/userApi";
import { DeleteModal } from "../../../components/DeleteModal/DeleteModal";
import useToast from "../../../hooks/useToast";
import useCustomNavigate from "../../../hooks/useNavigate";
import { IoMdOpen } from "react-icons/io"; // ✅ Import Redirect Icon

const ProjectsTable: React.FC = () => {

    const {showError,showSuccess} = useToast()
    const {goTo} = useCustomNavigate()

    const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
    const [propertyToDelete, setPropertyToDelete] = useState<string | null>(null); // Store the property ID to delete

    const queryParams = {
        properties: false,
        propertiesV2: false, // ✅ Sirf propertiesV2 fetch karega
        interestedProperties: false,
        shortlistedProperties: false,
        projectsAdded:true,
    };



    const { data: userProperties, isLoading, error,refetch } = useUserProperties(queryParams);

    console.log("User Properties:", userProperties, isLoading, error);

    // ✅ Define columns for the table
    const columns = [
        { title: "S. No.", dataIndex: "serialNo", key: "serialNo", width: 80 }, // ✅ Serial Number Column
        { title: "Property ID", dataIndex: "propertyId", key: "propertyId", width: 150 }, // ✅ Property ID Column
        { title: "Property Type", dataIndex: "propertyType", key: "propertyType", width: 200 },
        { title: "Location", dataIndex: "location", key: "location", width: 250 },
        { title: "Price", dataIndex: "price", key: "price", width: 200 },
        { title: "Status", dataIndex: "status", key: "status", width: 200 },
        {
            title: "Interested Users",
            dataIndex: "interestedUsers",
            key: "interestedUsers",
            width: 150,
            render: (_: any, record: any) => (
                <div className="flex items-center justify-center">
                <IoMdOpen
                    size={22}
                    className="text-blue-500 cursor-pointer hover:text-blue-700 transition"
                    onClick={() => goTo(`/properties/${record.key}/interested-users`)}
                />
                </div>
                
            ),
        },
    ];

    const data = userProperties?.projectsAdded?.map((property: any, index: number) => ({
        key: property._id || index.toString(),
        serialNo: index + 1,
        propertyId: property._id || "N/A",
        propertyType: property.basicDetails?.bhkType || "N/A",
        location: property.basicDetails?.location?.formatted_address || "N/A",
        bedrooms: property.floorPricingDetails?.[0]?.bhkType || "N/A",
        price: property.projectDetails?.price || property.basicDetails?.price ? `₹${property.projectDetails?.price || property.basicDetails?.price}` : "N/A",
        status: property.projectDetails?.status || "N/A",
    })) || [];
    



    const handleEdit = (record: any) => {
        console.log("Edit Clicked for:", record);
        goTo(`/properties/edit/${record.key}`)
    };

    
    const handleView = (record: any) => {
        console.log("View Clicked for:", record);
    };

     // ✅ Navigate to Interested Users Page
     const handleShowInterestedUsers = (record: any) => goTo(`/properties/${record.key}/interested-users`);

     // Open the delete modal and set the property to delete
     const handleDelete = (record: any) => {
        setPropertyToDelete(record.key); // Set the property ID to be deleted
        setIsModalOpen(true); // Open the modal
    };


    // Confirm deletion and call deleteProperty function
    const handleConfirmDelete = async () => {
        if (!propertyToDelete) return;

        try {
            await UserApi.deleteProperty(propertyToDelete); // Call the delete API
            showSuccess("Property deleted successfully!");
            // Refetch the properties after successful deletion
            refetch();
            setIsModalOpen(false); // Close the modal after successful deletion
        } catch (error: any) {
            showError(error.message || "Failed to delete property.");
            console.log("errorerrorerror",error)
        }
    };


    return (
        <div className="w-full max-w-[150vh] overflow-hidden "> {/* Prevents page overflow */}
        
            <DynamicTable 
            columns={columns} 
            data={data} 
            loading={isLoading} 
            rowsPerPage={5}
            actions={[
                { 
                    label: <AiOutlineEdit size={20} />, // ✅ Edit Icon
                    onClick: handleEdit, 
                    className: "text-green-500"
                },
                { 
                    label: <AiOutlineDelete size={20} />, // ✅ Delete Icon
                    onClick: handleDelete, 
                    className: "text-red-500"
                },
                { 
                    label: <AiOutlineEye size={20} />, // ✅ View Icon
                    onClick: handleView, 
                    className: "text-blue-500"
                },
                
            ]}
            />

            {/* Pass props to the DeleteModal component */}
            <DeleteModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)} // Close modal on cancel
                onConfirm={handleConfirmDelete} // Call handleConfirmDelete on confirm
                itemName={`Property ID: ${propertyToDelete}`} // You can modify this if needed
            />
        </div>
    );
};

export default ProjectsTable;
